import * as React from "react";
const SvgFiRrFaceSunglassesAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-sunglasses-alt_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m8.98 10.196-.039.195a2.006 2.006 0 0 1-1.961 1.608h-2.137a2 2 0 0 1-1.94-1.515l-.278-1.113a2.4 2.4 0 0 1 1.29-.372H20c.301 0 .583.134.773.366a1 1 0 0 1 .208.83zM12 2c3.728 0 6.98 2.054 8.699 5.086a3 3 0 0 0-.7-.086h-4.085a4.37 4.37 0 0 0-2.765 1h-2.297a4.37 4.37 0 0 0-2.765-1H4.002c-.239 0-.473.032-.7.086C5.022 4.054 8.274 2 12.001 2zM3.228 9.366A1 1 0 0 1 4.001 9h4.085c.464 0 .908.13 1.29.372l-.278 1.113A2 2 0 0 1 7.158 12H5.021c-.95 0-1.775-.677-1.961-1.608l-.039-.195a1 1 0 0 1 .208-.83zM12 22c-5.295 0-9.629-4.139-9.967-9.35A4 4 0 0 0 5.021 14h2.137a3.99 3.99 0 0 0 3.88-3.03l.243-.97h1.439l.243.97a3.99 3.99 0 0 0 3.88 3.03h2.137a4 4 0 0 0 2.988-1.35C21.63 17.86 17.296 22 12.001 22zm4.894-5.721a1 1 0 0 1 .026 1.414C14.699 20 11.915 20 11 20a1 1 0 1 1 0-2c.779 0 2.848 0 4.479-1.693a1 1 0 0 1 1.414-.027z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-sunglasses-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSunglassesAlt;
